import React from 'react';
import { AccordionRuleHeader } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/AccordionRuleHeader';
import { useGetEmailNotificationSubheader } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/EmailNotificationRule/hooks/useGetEmailNotificationSubheader';

export interface EmailNotificationRuleHeaderProps {
  isActive: boolean;
}

export function EmailNotificationRuleHeader({
  isActive,
}: EmailNotificationRuleHeaderProps): JSX.Element {
  const { subheader } = useGetEmailNotificationSubheader();

  return (
    <AccordionRuleHeader
      showSubheader={!isActive}
      header="Diner notification"
      subheader={subheader}
    />
  );
}
